import config from "config/config.js";
import getFreshToken from "api/xsrfToken.js";

const setFavorite = restaurantId => {
  const xsrfToken = getFreshToken();

  const endpoint = `${config.baseUrl}/api/favorite`;
  const data = { restaurantId };
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "https://www.foodiestrip.com",
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": xsrfToken
    },
    credentials: "include",
    body: JSON.stringify(data)
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(response => {
      return response;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default setFavorite;
